export var CustomEventType;
(function (CustomEventType) {
    CustomEventType["ONETRUST_GROUPS_UPDATED"] = "OneTrustGroupsUpdated";
})(CustomEventType || (CustomEventType = {}));
